import React, { useRef, useEffect, useState } from "react";
import { Form, message, Modal, Input } from "antd";
import { YHDrawer } from "@/components/YhDrawer";
import { FormItemTypeEnum, IYhForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { YhForm } from "@/components/YhFormBox";
import { getFormValidatorErrText, momentFormat } from "@/utils/utils";
import { useReportBillModel } from "../reportBillModel";
import useGlobalModel, { transOptions } from "@/model/globalModel";
import { reportBillService } from "../reportBillService";
import { getBaseImgLookUrl } from "@/utils/constants";
import { Image } from 'antd';
import { PlusOutlined } from '@ant-design/icons'; // 导入添加图标
import { globalPrompt } from "@/components/message";

// 结算
export function DispatchDrawer() {
    // 审批节点状态样式映射
    const statusStyles: any = {
        2: { color: '#52C41A', bgColor: '#1890FF', borderColor: 'rgba(24, 144, 255, 0.3)' },//审批通过
        8: { color: '#d82007', bgColor: '#F5222D', borderColor: 'rgba(245, 34, 45, 0.25)' },//审批驳回
        0: { color: '#FF9900', bgColor: '#FFC53D', borderColor: 'rgba(255, 197, 61, 0.3)' },//待处理
    };
    const { dispatchVisible: visible, setDispatchVisible, selectedRow, } = useReportBillModel();

    // 存储从服务器获取的详情数据
    const [detailData, setDetailData] = React.useState<any>({});
    // 加载状态
    const [loading, setLoading] = React.useState(false);

    // 进入页面单条查询，获取数据填入
    useEffect(() => {
        if (visible && selectedRow?.id) {
            fetchDetail(selectedRow.id);
        }
    }, [visible, selectedRow?.id]);

    // 获取详情数据的函数
    const fetchDetail = async (id: string) => {
        setLoading(true);
        try {
            const res = await reportBillService.one(id);
            setDetailData({
                ...res.retData,
                fileMsg: res.retData.fileMsg ? res.retData.fileMsg.split(",") : []
            });
        } catch (error) {
            message.error('获取详情失败');
            console.error('获取详情失败:', error);
        } finally {
            setLoading(false);
        }
    }

    // 监听批量录入字段
    const onChange = (changedValues: { [key: string]: any }) => {
        if ('isBatch' in changedValues) {
            // 批量录入逻辑
        }
    }

    const onCancel = () => {
        setDispatchVisible(false);
    }

    const onOk = () => {
        setDispatchVisible(false);
    }

    const onFinish = (val: any) => {
        // 表单提交逻辑
    }

    // 点击添加图标时显示对话框
    const showAddModal = () => {
        let additionalContent = ''
        globalPrompt("modal", {
            title: "添加维修附加项！",
            type: "success",
            text: <Input.TextArea
                onChange={(e) => additionalContent = e.target.value}
                placeholder="请输入维修附加项内容"
                rows={4}
            />,
            okText: "确定",
            onOk: async () => {
                if (!additionalContent.trim()) {
                    message.warning('请输入维修附加项内容');
                    // 返回Promise.reject阻止对话框关闭
                    return Promise.reject();
                }

                // 调用接口提交数据
                try {
                    await reportBillService.addAdditionalItems({
                        id: selectedRow?.id,
                        additionalItems: additionalContent.trim()
                    });
                    message.success('维修附加项添加成功');
                    // 重新获取详情数据刷新页面
                    if (selectedRow?.id) {
                        fetchDetail(selectedRow.id);
                    }
                } catch (error) {
                    message.error('维修附加项添加失败');
                    console.error('添加失败:', error);
                    return Promise.reject();
                }
            },
            cancelText: "取消",
            onCancel: () => {
            }
        })
    };

    // 带标题的图片预览组件
    const ImagePreview: React.FC<{ url?: any; title: string }> = ({ url, title }) => {
        return (
            <div style={{ width: 'calc(50% - 16px)', boxSizing: 'border-box' }}>
                <Image
                    src={getBaseImgLookUrl(url)}
                    style={{ width: '180px', height: '140px', borderRadius: 4, border: '1px solid #e8e8e8' }}
                />
                <div style={{ textAlign: 'center', marginTop: 4, fontSize: 12, color: '#666' }}>
                    {title}
                </div>
            </div>
        );
    };

    // 多张图片预览组件
    const MultiImagePreview: React.FC<{ urls?: string[]; alts?: string[] }> = ({ urls, alts }) => {
        return (
            <div style={{ margin: '8px 0', display: 'flex', flexWrap: 'wrap', gap: 10 }}>
                {urls?.map((url, index) => (
                    <div key={index} style={{ width: 'calc(33.333% - 7px)' }}>
                        <Image
                            src={getBaseImgLookUrl(url)}
                            alt={alts?.[index] || `图片${index + 1}`}
                            style={{ width: '120px', height: '120px', objectFit: 'cover', borderRadius: 4, border: '1px solid #e8e8e8' }}
                        />
                    </div>
                ))}
            </div>
        );
    }

    const formConfig: IYhForm<any> = {
        onFinish,
        disabled: true,
        formValues: { ...detailData },
        labelCol: { span: 6 },
        onChange,
        items: [
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆牌照",
                fieldName: "licensePlate",
                span: 24,
                disable: true
            },
            // {
            //     type: FormItemTypeEnum.Other,
            //     fieldLabel: "图片附件",
            //     fieldName: "licensePlatePhoto",
            //     span: 24,
            //     formItem: (
            //         <Form.Item name="fileList" label="图片附件" labelCol={{ span: 6 }}>
            //             <div style={{ display: 'flex', flexWrap: 'wrap' }}>
            //                 <ImagePreview
            //                     url={detailData.licensePlatePic}
            //                     title="车辆牌照"
            //                 />
            //                 <ImagePreview
            //                     url={detailData.mileagePic}
            //                     title="车辆里程"
            //                 />
            //             </div>
            //         </Form.Item>
            //     )
            // },
            {
                type: FormItemTypeEnum.Input,
                fieldLabel: "维修类型",
                fieldName: "serviceNatureName",
                span: 24,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆里程",
                fieldName: "mileage",
                span: 24,
                disable: true
            }, {
                type: FormItemTypeEnum.Input,
                fieldLabel: "车辆品牌",
                fieldName: "brandName",
                span: 24,
                disable: true
            },
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "故障描述",
                fieldName: "faultDesc",
                span: 24,
                formItem: (
                    <Form.Item
                        name="faultDesc"
                        label={
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                故障描述

                            </div>
                        }
                        labelCol={{ span: 6 }}
                    >
                        <Input.TextArea
                            value={detailData.faultDesc || ''}
                            disabled
                            rows={4}
                            placeholder="无故障描述"
                        />
                        {!detailData.additionalItems && detailData.status == 'repair_report.audited' && (
                            <div
                                onClick={showAddModal}
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    padding: '6px 16px',
                                    backgroundColor: '#E6F7FF',
                                    color: '#1890FF',
                                    borderRadius: '4px',
                                    cursor: 'pointer',
                                    border: '1px solid rgb(24, 144, 255)',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    marginTop: '8px',
                                }}
                            >
                                <PlusOutlined style={{ fontSize: '16px' }} title="添加维修附加项" />
                                <span>添加维修附加项</span>
                            </div>
                        )
                        }
                    </Form.Item >
                )
            },
            ...(detailData.additionalItems ? [{
                type: FormItemTypeEnum.TextArea,
                fieldLabel: "维修附加项",
                fieldName: "additionalItems",
                span: 24,
                disable: true,
            }] : []),
            {
                type: FormItemTypeEnum.Other,
                fieldLabel: "故障照片",
                fieldName: "faultPhotos",
                span: 24,
                formItem: (
                    <Form.Item name="fileList" label="故障图片" labelCol={{ span: 6 }}>
                        <MultiImagePreview
                            urls={detailData.fileMsg}
                            alts={detailData.fileMsg}
                        />
                    </Form.Item>)
            }
        ]
    };

    // 生成的审批节点
    const approvalNodes: any = detailData ? detailData.availNode : [];

    return (
        <YHDrawer
            {...{
                title: '报修详情',
                visible,
                cancelText: "返回",
                onCancel,
                width: 600,
                loading,
                onOk
            }}
        >
            <YhForm {...formConfig} />
        </YHDrawer>
    )
}
